<style lang="less">
    @import './styles/infor-card.less';
</style>

<template>
    <Card :padding="0">
        <div class="infor-card-con">
            <Col class="infor-card-icon-con" :style="{backgroundColor: color, color: 'white'}" span="8">
                <Row class="height-100" type="flex" align="middle" justify="center">
                    <Icon :type="iconType" :size="iconSize"></Icon>
                </Row>
            </Col>
            <Col span="16" class="height-100">
                <Row type="flex" align="middle" justify="center" :class="number!='2'?'height-100':'height-100 height-my'">
                    <count-up 
                        :class="number!=2?'infor-card-count user-created-count':'infor-card-count user-created-count infor-my'" 
                        :id-name="idName" 
                        :end-val="endVal" 
                        :color="color"
                        :countSize="countSize"
                        :countWeight="countWeight"
                        :number="number==2?2:3"
                    >
                        <p class="infor-intro-text" slot="intro">{{ introText }}</p>
                    </count-up>
                    <count-up 
                        v-if="number=='2'"
                        :class="number!=2?'infor-card-count user-created-count':'infor-card-count user-created-count infor-my'" 
                        :id-name="idName+1" 
                        :end-val="endValTwo" 
                        :color="color"
                        :countSize="countSize"
                        :countWeight="countWeight"
                        number="2"
                    >
                        <p class="infor-intro-text" slot="intro">{{ introTextTwo }}</p>
                    </count-up>
                </Row>
            </Col>
        </div>
    </Card>
</template>

<script>
import countUp from './countUp.vue';

export default {
    name: 'inforCard',
    components: {
        countUp
    },
    props: {
        idName: String,
        endVal: Number,
        endValTwo: Number,
        color: String,
        iconType: String,
        introText: String,
        introTextTwo:String,
        countSize: {
            type: String,
            default: '30px'
        },
        countWeight: {
            type: Number,
            default: 700
        },
        iconSize: {
            type: Number,
            default: 40
        },
        number:String,
    }
};
</script>

